import { Backdrop } from "@mui/material";
import Lottie from "lottie-react";
import { ReactNode, useEffect, useState } from "react";
import { Box } from "../../common/components";
import AnimatedLogo from "./animatedJameoLogo.json";
import { AppLoadingContext } from "./AppLoadingContext";
import { useLocation } from "react-router-dom";

interface Props {
  children: ReactNode;
}

export const AppLoadingProvider = ({ children }: Props) => {
  const [isAppLoading, setIsAppLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsAppLoading(false);
  }, [location, setIsAppLoading]);

  return (
    <AppLoadingContext.Provider value={{ isAppLoading, setIsAppLoading }}>
      <Backdrop
        sx={(theme) => ({
          color: "#fff",
          zIndex: theme.zIndex.drawer + 1,
          background: "rgba(18, 33, 59, 0.20)",
          width: "100vw",
          height: "100vh",
        })}
        open={isAppLoading}
      >
        <Box
          sx={{
            position: "relative",
            width: "100vw",
            height: "100vh",
            "&>div": {
              width: "100%",
              height: "100%",
            },

            "& svg": {
              width: "fit-content !important",
              position: "absolute",
              top: "314px",
              maxHeight: "100px",
              left: "50%",
              transform: "translateX(-50%) !important",
            },
          }}
        >
          <Lottie animationData={AnimatedLogo} loop={true} />
        </Box>
      </Backdrop>
      {children}
    </AppLoadingContext.Provider>
  );
};
